<template>
  <input :id="id" type="hidden" :name="name" :value="value" />
</template>

<script setup lang="ts">
import type { TFileUploaderField } from '~/src/types/download'

type TFormInputHiddenProps = Partial<TFileUploaderField> & {
  value?: number | string
}

withDefaults(defineProps<TFormInputHiddenProps>(), {
  name: null,
  id: null,
  value: '',
})
</script>
